import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { BadgeDot } from "./BadgeDot";
import { OverlayWrapper } from "./OverlayWrapper";
export const badgeClasses = {
    root: "MinervaBadge-root",
    badge: "MinervaBadge-badge",
};
export const badgeSlots = {
    badge: BadgeDot,
};
export const Badge = memo((props) => {
    const { label, invisible: _invisible, placement: _placement, placementOffset: _placementOffset, color, colorSet, invertColors, slots, slotProps, children, className, sx, ...rest } = useDefaultProps({ component: "Badge", props });
    const invisible = _invisible ?? label === undefined;
    return (_jsx(SlotsProvider, { baseSlots: badgeSlots, slots: slots, children: ({ badge: Badge }) => {
            const placement = _placement ?? {
                horizontal: "right",
                vertical: "top",
            };
            const offsetFactor = invisible || label === undefined ? 0.5 : 2;
            const offsetModifier = {
                horizontal: placement?.horizontal === "center" ? 0 : -1,
                vertical: placement.vertical === "center" ? 0 : -1,
            };
            const placementOffset = _placementOffset ?? {
                horizontal: offsetFactor * offsetModifier.horizontal,
                vertical: offsetFactor * offsetModifier.vertical,
            };
            return (_jsx(OverlayWrapper, { className: clsx([badgeClasses.root, className]), placement: placement, placementOffset: placementOffset, sx: mergeSx({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                }, sx), content: !invisible && (_jsx(Badge, { color: color, colorSet: colorSet, invertColors: invertColors, ...slotProps?.badge, className: clsx([
                        badgeClasses.badge,
                        slotProps?.badge?.className,
                    ]), children: label })), ...rest, children: children }));
        } }));
});
//# sourceMappingURL=Badge.js.map